/* eslint-disable import/prefer-default-export */
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import '../../../../css/challenge/proofOfWork/proofOfWork.scss';

import App from './App';
import { RenderChallenge } from './interface';
import { RequestServiceDefault } from '../../../common/request';

// Export some additional enums that are declared in the shared interface (they
// are also defined in the shared interface, but we need to expose them in the
// object hierarchy for the challenge component).
export { ErrorCode } from './interface';

// Global instance since we do not need Proof of work parameters for
// instantiation.
const requestServiceDefault = new RequestServiceDefault();

/**
 * Renders the Proof-of-work Challenge UI for a given set of parameters.
 * Returns whether the UI could be successfully rendered.
 */
export const renderChallenge: RenderChallenge = ({
  containerId,
  sessionId,
  onChallengeCompleted,
  onChallengeInvalidated,
  onModalChallengeAbandoned
}) => {
  const container = document.getElementById(containerId);
  if (container !== null) {
    // Remove any existing instances of the app.
    unmountComponentAtNode(container);

    // Render the app on the selected element.

    // Instantiate services externally to the app, which will offer future
    // flexibility (e.g. for mocking).
    render(
      <App
        sessionId={sessionId}
        requestService={requestServiceDefault}
        onChallengeCompleted={onChallengeCompleted}
        onChallengeInvalidated={onChallengeInvalidated}
        onModalChallengeAbandoned={onModalChallengeAbandoned}
      />,
      container
    );
    return true;
  }

  return false;
};
